import { RtuevoReadingType } from "src/model/enum/enumRtuevoReadingType";

/**
 * This handles adding new Rtuevo Sinapsi device
 */
export class RtuevoSinapsiDevice {
  public rtuevoPollingSeconds: number = 0;
  public rtuevoApiKey: string = "";
  public rtuevoSerialNumber: string = "";
  public rtuevoDescription: string = "";
  public rtuevoReadingType: number = RtuevoReadingType.DATAPOINTS;

  constructor(rtuevoSinapsiDevice: any) {
    if (rtuevoSinapsiDevice) {
      Object.assign(this, rtuevoSinapsiDevice);
    }
  }
}
